export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ./~/d3-chord/index.js
// module id = 1446
// module chunks = 0